import {LinkType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/meta_bar.types';
import {GetHeaderBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {useTrackFeature} from '@aboutyou/tracking';
import {
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useOutletLinkConfig} from '../../../features/OutletLink/useOutletLinkConfig';
import {MetaBarLanguageCountrySwitch} from './MetaBarLanguageCountrySwitch';
import {MetaBarItemWithLink, MetaBarLinks} from './MetaBarLinks';

export const metaBarLinkTypes = [
  LinkType.CONTACT,
  LinkType.SECOND_HAND_SERVICE,
];

export const MetaBarContentView: React.FC<
  React.PropsWithChildren<GetHeaderBulkResponse['metaBarSection']>
> = ({countrySwitch, links}) => {
  const trackFeature = useTrackFeature();

  const {ayOutletUrl, outletLabel, showOutletLink} =
    useOutletLinkConfig('metabar_desktop');

  const handleOutletClick = () => {
    trackFeature({eventType: 'click', label: 'Outlet'});
  };

  return (
    <>
      <Content>
        {showOutletLink && (
          <StyledMetaBarItemWithLink
            to={ayOutletUrl}
            onClick={handleOutletClick}
            data-testid="ayOutletLink-metabar"
          >
            <StyledIcon asset={GenericIconName.Percent} size="XS" />
            {outletLabel}
          </StyledMetaBarItemWithLink>
        )}
        <MetaBarLinks
          links={links.filter(link => metaBarLinkTypes.includes(link.type))}
        />
      </Content>
      <Content>
        <MetaBarLanguageCountrySwitch countrySwitch={countrySwitch} />
      </Content>
    </>
  );
};

const StyledMetaBarItemWithLink = styled(MetaBarItemWithLink)`
  gap: 4px;
`;

const StyledIcon = styled(Icon)`
  background: ${COLORS.Yellow};
  border-radius: 3px;
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  color: ${COLORS.Grey1};
  font-size: ${FONT_SIZES.px10};
  border: solid ${COLORS.Grey3};
  border-width: 0 1px;

  ${MetaBarItemWithLink} + ${MetaBarItemWithLink} {
    border-left: 1px solid ${COLORS.Grey3};
  }
`;
